import { HttpEvent, HttpHandler, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptorService {

  constructor(private activatedRoute:ActivatedRoute) { }

  intercept(
    httpRequest: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let modifiedHttpRequest = httpRequest;

    const lang = this.activatedRoute.snapshot.queryParams['lang'];
    if (lang) {
      const params = httpRequest.params.set('lang', lang);
      modifiedHttpRequest = httpRequest.clone({ params });
    }
    const token = localStorage.getItem('token');
    if (token) {
      const headers = modifiedHttpRequest.headers.set('Authorization', `${token}`);
      modifiedHttpRequest = modifiedHttpRequest.clone({ headers });
    }
    return next.handle(modifiedHttpRequest);
  }
}
